<template>
  <div class="index-container" ref="indexContainer">
    <el-container v-if="loadExtensionState > 0" class="app-index">
      <el-header height="43px">
        <div class="logo">
          <div class="logo-img" v-if="logoUrl" >
            <img :src="logoUrl"/>
          </div>
          <div :class="['log-app-name', hasTheme && 'log-app-name-theme-color']" v-else-if="applicationName">
            <p>{{applicationName.slice(0, 9)}}</p>
            <p v-show="applicationName.length > 9">{{applicationName.length > 17 ? applicationName.slice(9, 17) + '...' : applicationName.slice(9)}}</p>
          </div>
        </div>
        <el-menu
          :default-active="guideChoose"
          mode="horizontal"
          :background-color="menuColor.mainColor"
          :text-color="menuColor.textColor"
          :active-text-color="menuColor.activeTextColor"
          :class="['homePageMenu', hasTheme && 'homePageMenu-theme']">
          <template v-for="(item,index) in headerMenu">
            <el-menu-item
              v-if="item.name !== '功能点'"
              :key="item.id"
              :index="item.id"
              @click="clickMenu(index,item.id)">
              {{item.name}}
            </el-menu-item>
          </template>
        </el-menu>
        <div :class="['user', hasTheme && 'user-theme']">
          <!-- 这里的图标需要换 -->
          <span :class="['username', hasTheme && 'username-theme']">
            <i class="fa fa-user"></i>
            <span class="username-padding" :class="[hasFunctionsMenu && 'username-border-right']">{{username}}</span>
          </span>
          <template v-for="item in headerMenu">
            <div :class="['point', hasTheme && 'point-theme']" v-if="item.name === '功能点'" :key="item.id">
              <div style="display:inline"
                   v-for="childItem in item.children"
                   :key="childItem.id"
                   :index="'/main'+childItem.link"
                   @click="toPoint(childItem.link,childItem.name)">
                <el-button v-if="childItem.name==='通讯录'" icon="fa fa-address-book-o" class="icon-button" size="mini"
                           title="通讯录"></el-button>
                <el-button v-else-if="childItem.name==='消息'" icon="fa fa-bell-o" class="icon-button" size="mini"
                           title="消息"></el-button>
                <el-button v-else-if="childItem.name==='共享文档'" icon="fa fa-file-text-o" class="icon-button" size="mini"
                           title="共享文档"></el-button>
                <!-- 华奥专用技术支持图标 -->
                <el-button v-else-if="childItem.name==='技术支持'" icon="fa fa-headphones" class="icon-button" size="mini" title="技术支持"></el-button>
                <el-button v-else icon="fa fa-file-text-o" class="icon-button" size="mini"
                           :title="childItem.name"></el-button>
              </div>
            </div>
          </template>
          <i class="fa fa-sign-out" title="退出" @click="logout"></i>
        </div>
      </el-header>
      <el-container>
        <!-- 左侧导航 -->
        <span :class="['menuHide', {'menuShow': menuHideleft === 0}]" @click="menuHide" :style="{left:menuHideleft+'px'}"></span>
        <div :class="['app-index-aside', hasTheme && 'app-index-aside-theme']" v-show="!isCollapse">
          <el-input class="search" v-model="keyword" placeholder="搜索\常用" @focus='getHistory' clearable @blur="clearList"></el-input>
          <el-collapse-transition>
            <div class="search-list" v-show="showList">
              <div v-if="keyword.trim() === ''" :class="['list-container','history-result', hasTheme && 'list-container-color']">
                <div class="title">常用功能</div>
                <div class="list">
                  <div v-show="historyList2.length > 0" class="item" :title="item.name" v-for="item in historyList2" :key="item.link" @click="itemClick(item)">{{ item.name }}</div>
                  <div v-show="historyList2.length === 0" class="no-history">无</div>
                </div>
                <div class="title">最近使用</div>
                <div class="list">
                  <div v-show="historyList.length > 0" class="item" :title="item.name" v-for="item in historyList" :key="item.link" @click="itemClick(item)">{{ item.name }}</div>
                  <div v-show="historyList.length === 0" class="no-history">无</div>
                </div>
              </div>
              <div v-else :class="['list-container', 'search-result-list', hasTheme && 'list-container-color']">
                <div class="title">搜索结果</div>
                <div class="list">
                  <div v-show="searchMenuList.length > 0" class="item" :title="item.menuName" v-for="item in searchMenuList" :key="item.link" @click="itemClick(item)">{{ item.menuName }}</div>
                  <div v-show="searchMenuList.length === 0" class="no-search">无</div>
                </div>
              </div>
            </div>
          </el-collapse-transition>
          <div :class="['menu-container', hasTheme && 'menu-container-theme']">
            <el-menu
              :class="['el-menu-vertical', hasTheme && 'el-menu-vertical-theme']"
              :background-color="hasTheme ? '#f5f5f5' : '#29282e'"
              :text-color="hasTheme ? '#232323' : '#ffffff'"
              router
              :default-active="defaultChoose"
              :default-openeds="openSubMenus">
              <template v-for="item in homeMenu">
                <menu-list :key="item.id" @toChildRouter="toChildRouter" :menuKey="item.id" :data="item" :currentMenuId="currentMenuId"></menu-list>
              </template>
            </el-menu>
          </div>
        </div>
        <el-main class="app-main">
          <!-- 标签页 -->
          <tags-view ref="tagView"
             v-show="showTagView"
             :menuHideleft="menuHideleft"
             :menuIds="menuIds"
             :currentMenuId="currentMenuId"
             :cachedViews="cachedViews"
             :headerMenu="headerMenu"
             :todoProcessNum="todoProcessNum"
             @activeTagEvent="activeTagEvent"
             @setCachedViews='getCachedViews'
             @firstEntry="firstEntry"
             @setCurrentId='getCurrentId'/>
          <!-- 主体内容 -->
          <div ref="currentView" v-show="!centerDialogVisible" class="content-container">
            <template v-for="(item) in dynamicCacheView.filter(n=>n.name==='FormRuntime')">
              <template>
                <form-runtime ref="form" v-show="($route.params.id===item.id||$route.params.id===item.reportId)&&$route.name.includes('FormRuntime')" :key="item.id" :id="item.reportId" @customEvent="customEvent"></form-runtime>
              </template>
            </template>
            <template v-for="(item) in dynamicCacheView.filter(n=>n.name==='ReportRuntime')">
              <template>
                <report-runtime ref="report" v-show="($route.params.id===item.id||$route.params.id===item.reportId)&&$route.name.includes('ReportRuntime')"  :key="item.id" :id="item.reportId" @customEvent="customEvent"></report-runtime>
              </template>
            </template>
            <template v-for="(item) in dynamicCacheView.filter(n=>n.name==='PageRuntime')">
              <template>
                <page-runtime ref="page" v-show="($route.params.id===item.id||$route.params.id===item.reportId)&&$route.name.includes('PageRuntime')"  :key="item.id" :id="item.id" @customEvent="customEvent"></page-runtime>
              </template>
            </template>
            <keep-alive :include="cachedViews">
              <router-view v-if="!(($route.name).includes('ReportRuntime')||($route.name).includes('FormRuntime')||($route.name).includes('PageRuntime'))" @updateTodoProcessNum="updateTodoProcessNum"/>
            </keep-alive>
          </div>
          <div v-show="centerDialogVisible" class="content-container"></div>
        </el-main>
      </el-container>
      <el-dialog
        class="security-dialog"
        title="提示"
        :show-close="false"
        @open="clearPassword"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="centerDialogVisible"
        width="392px"
        center>
          <div :class="['dialog-title' ,!hasSettingPwd && 'hasSettingPwd']">{{dialogTitle}}</div>
          <el-form v-show="hasSettingPwd" :inline="true" :model="securityPasswordForm" @submit.native.prevent>
            <el-form-item label="安全密码" :error="errorMessage">
              <el-input ref="securityPassword" v-model="securityPasswordForm.password" type="password" autocomplete="off" @keydown.enter.native="dialogConfirm"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogConfirm">{{confirmBtnText}}</el-button>
            <el-button @click="dialogCancel">{{cancelBtnText}}</el-button>
          </span>
      </el-dialog>
      <el-dialog
        :class="['header-functional-point',functionalPoint.support && 'functional-point-help-height']"
        v-if="functionalPoint.visible"
        :title="functionalPoint.title"
        :visible.sync="functionalPoint.visible"
        :width="functionalPoint.width"
        :close-on-click-modal="false"
        center>
          <system-support v-if="functionalPoint.support"></system-support>
          <report-runtime v-else :id="functionalPoint.functionId"></report-runtime>
          <span slot="footer" class="dialog-footer">
            <el-button @click="functionalPoint.visible = false">取 消</el-button>
            <el-button type="primary" @click="functionalPoint.visible = false">确 定</el-button>
          </span>
      </el-dialog>
    </el-container>
    <div v-if="loadExtensionState <= 0 && Object.keys(tenantInfo).length > 0" class="index-model">
      <div class="model-title">
        <div class="tenant-logo">
          <img :src="tenantInfo.logo" alt="">
        </div>
        <div class="tenant-name">{{tenantInfo.applicationName}}</div>
      </div>
      <div class="model-body">
        <template v-if="loadExtensionState === 0">
          正在努力加载中 <i class="el-icon-loading"></i>
        </template>
        <template v-if="loadExtensionState === -1">
          加载失败，请<a href="javascript:location.reload()">刷新</a>或稍后重试...
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import TagsView from '../shared/tagsView/index.vue'
import SystemSupport from './system-support.vue'
import ReportRuntime from '@/components/report/runtime/report-runtime.vue'
import FormRuntime from '@/components/form/runtime/form-runtime.vue'
import PageRuntime from '@/components/page/runtime/page-runtime'
import tokenStorage from '@/plugins/tokenStorage'
import Vue from 'vue'
import CookieOperation from '@/plugins/cookie'
import { loadExtensionScript } from '@/plugins/redcatSdk'
import waterMarkMixin from '@/components/public/waterMark/waterMarkMixin'
import { getUserInfo, userInfo } from '@/store/app-common-data/userInfo.js'
import { registerSdkComponents } from '@/store/form/componentDefaults.js'
// admin账号固定菜单（在系统下）
let adminDefaultMenu = {
  children: [{
    link: '/change-password',
    name: '修改密码',
    id: '169572EC-A220-0006-B645-238CC560F463',
    parentId: '169572EC-A220-0006-B645-238CC560F462',
    sort: 200,
    children: [],
    icon: null
  }],
  icon: null,
  id: '169572EC-A220-0006-B645-238CC560F462',
  link: null,
  name: '个人设置',
  parentId: '169572EC-A220-0006-B645-238CC560F468',
  sort: 400
}
export default {
  name: 'App',
  provide: {
    leftMenu: {
      width: 200
    },
    // uuid：用来标识，为了触发监听，因为如果打开的标签页关闭之后，再次点进是不会触发监听的，因为值没有更改过
    currentMenu: {id: '', uuid: ''}
  },
  mixins: [waterMarkMixin],
  data () {
    return {
      // defaultLogo,
      cachedViews: [],
      dynamicCacheView: [],
      tabViewsLength: '',
      lastRouter: '',
      index: 0,
      dialogTitle: '',
      errorMessage: '',
      centerDialogVisible: false,
      headerMenu: [],
      menuIds: [],
      currentMenuId: '',
      homeMenu: [],
      keyword: '',
      isCollapse: false,
      username: '',
      defaultChoose: '',
      openSubMenus: [],
      guideChoose: '',
      menuColor: {
        mainColor: '',
        textColor: '',
        activeTextColor: ''
      },
      saveGuideChoose: '',
      securityPasswordForm: {
        password: ''
      },
      cancelBtnText: '取消',
      confirmBtnText: '确认',
      hasSettingPwd: 'false',
      timer: null,
      isAddMenu: false,
      logoUrl: '',
      applicationName: '',
      functionalPoint: {
        functionId: '', // 功能点id
        support: false, // 系统支持
        visible: false,
        title: '',
        width: '80%'
      },
      historyList: [], // 最近使用
      historyList2: [], // 常用功能
      showList: false,
      searchMenuList: [],
      tenantId: '',
      loadExtensionState: 0,
      tenantInfo: {},
      currentMenu: {id: '', uuid: ''},
      copyTabViews: [],
      adminDefaultMenu,
      // 所有菜单的集合，一层
      menuList: [],
      // 是否设置了主题
      hasTheme: false,
      todoProcessNum: 0
    }
  },
  components: {
    TagsView,
    ReportRuntime,
    FormRuntime,
    SystemSupport,
    PageRuntime,
    menuList: () => import('./menu-list.vue')
  },
  async created () {
    this._provided.currentMenu = this.currentMenu
    loadExtensionScript(exts => {
      this.loadExtensionState = 1
      this.$nextTick(() => {
        this.$refs.tagView && this.$refs.tagView.addTags()
        // 合并 sdk 中注册的组件
        registerSdkComponents()
      })
    }, exts => {
      this.loadExtensionState = exts && exts.src ? -1 : 1
      this.$nextTick(() => {
        this.$refs.tagView && this.$refs.tagView.addTags()
        // 合并 sdk 中注册的组件
        registerSdkComponents()
      })
    })
    let params = { 'domain': document.domain }
    let tenantInfo = localStorage.getItem('tenantInfo')
    // 复制链接->关闭浏览器->打开浏览器->黏贴链接->不需要登录->导致没有tenantInfo
    if (!tenantInfo) {
      await this.$axios.get('/system-api/application/getSettingByDomain', {params, timeout: 4000}).then(res => {
        tenantInfo = res.data.data
        localStorage.setItem('tenantInfo', JSON.stringify(res.data.data))
      })
    }
    try {
      // 上面的请求不一定有正确的返回值导致这边的JSON解析可能报错，后续方法不执行
      this.tenantInfo = tenantInfo ? JSON.parse(tenantInfo) : {}
    } catch (e) {
      console.warn(e.message)
      this.tenantInfo = {}
    }
    this.$axios.get('/shared-api/files/downloadUrl').then(res => {
      sessionStorage.setItem('downloadUrl', res.data)
      localStorage.setItem('downloadUrl', res.data)
    })
    this.$axios.get('/shared-api/files/cdnDownloadUrl').then(res => {
      sessionStorage.setItem('cdnDownloadUrl', res.data)
      localStorage.setItem('cdnDownloadUrl', res.data)
    })
    this.$axios.get('/shared-api/files/viewUrl').then(res => {
      sessionStorage.setItem('viewUrl', res.data)
      localStorage.setItem('viewUrl', res.data)
    })
    //  OSS上传相关信息
    this.$axios.get('/shared-api/files/oss').then(res => {
      // let region = ''
      // if (res.data.host) {
      //   region = res.data.host.match(/[^(https://ywdev. | http://ywdev.)].*(?=\.aliyun)/g)[0]
      // }
      sessionStorage.setItem('accessKeyId', res.data.accessId)
      sessionStorage.setItem('policy', res.data.policy)
      sessionStorage.setItem('signature', res.data.signature)
      // sessionStorage.setItem('region', region)
      sessionStorage.setItem('ossDownloadUrl', res.data.host)
    })
    // 登入相关
    this.$axios.get('/auth-api/oauth/currentUserInfo').then(res => {
      this.username = res.data.name
      sessionStorage.setItem('userId', res.data.id)
      sessionStorage.setItem('userName', res.data.name)
      if (res.data.username === 'admin' + res.data.tenantId) {
        this.isAddMenu = true
      }
    })
    // if (document.addEventListener) {
    //   document.addEventListener('DOMMouseScroll', this.pageTurn, false)
    // }

    // window.onmousewheel = document.onmousewheel = this.pageTurn
    // 根据域名取当前租户信息
    this.$axios.get('/system-api/application/getSettingByDomain', {
      params
    })
      .then((res) => {
        // 第一次获取到数据的之后就要设置背景色
        res.data.data && this.getElmenuBgColor(res.data.data.themeColor)
        // 判断是否从 开发者中心跳转过来的
        if (CookieOperation.get('isTest')) {
          document.title = `测试-${res.data.data.applicationName}`
        } else {
          if (res.data.data && res.data.data.applicationName) {
            document.title = res.data.data.applicationName
          } else {
            document.title = '红猫系统设计平台'
          }
        }
        if (res.data.data && res.data.data.logo) {
          this.logoUrl = res.data.data.logo
        } else {
          // this.logoUrl = defaultLogo
          this.applicationName = (res.data.data && res.data.data.applicationName) || '红猫平台'
        }
      })
      .catch(() => {
        document.title = '红猫系统设计平台'
        // this.logoUrl = defaultLogo
        this.applicationName = '红猫平台'
        // 这个接口失败了有可能其他地方成功了，依然要调用一次背景色设置方法
        this.getElmenuBgColor()
      })
    this.tenantId = CookieOperation.get('tenantId')
    let link = document.querySelector("link[rel*='icon']")
    if (link) {
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      if (this.tenantId === '1696BDBF-CC00-09CF-B406-9198CC9854E2') {
        link.href = '../../static/favicon1.ico'
      } else {
        link.href = '../../static/favicon.ico'
      }
    }
    // 初始化菜单栏
    this.initMenu()
    this.refresh()
    // 阻止浏览器默认的拖动事件
    this.initDragable()
    // 获取用户信息存储为全局变量 todo:已存在的重复接口请求行为可以后续替换
    getUserInfo()
  },

  beforeRouteUpdate (to, from, next) {
    this.lastRouter = from.path
    next()
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.tagView && this.$refs.tagView.addTags()
    })
    localStorage.removeItem('reportScrollTop')
    // dom在这个生命周期才会挂载在el上
    // 增加水印
    let container = this.$refs.indexContainer
    if (container) {
      this.getWaterMark({container: container, zIndex: 300})
    }
  },
  computed: {
    menuHideleft () {
      return this.isCollapse ? 0 : 200
    },
    showTagView () {
      return this.$route.name !== 'form-design' && this.$route.name !== 'process-design' && this.$route.name !== 'report-design'
    },
    hasFunctionsMenu () {
      let menus = this.headerMenu.find(c => c.name === '功能点')
      return menus && menus.children && menus.children.length > 0
    }
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    updateTodoProcessNum (value) {
      this.todoProcessNum = Number(value)
    },
    initMenu () {
      // 获取菜单列表
      this.$axios.get('/auth-api/menus/menusByUser').then((res) => {
        if (res.data) {
          let menuObj = this.getDisposeMenus(res.data)
          this.headerMenu = menuObj.menus
          this.menuIds = menuObj.menuIds
          this.menuList = menuObj.menusList
          sessionStorage.setItem('menuIds', JSON.stringify(this.menuIds))
          // 首页是否有权限
          // 代办
          let doingTask = this.findDoingTask({children: this.headerMenu}, '待办流程')
          if (doingTask) {
            sessionStorage.setItem('hasIndex', true)
          } else {
            sessionStorage.setItem('hasIndex', false)
          }
          this.refresh()
        }
      })
    },
    clearPassword () {
      this.securityPasswordForm.password = ''
    },
    getCachedViews (tabViews) {
      if (this.copyTabViews.length <= tabViews.length) {
        this.copyTabViews = this.$_.cloneDeep(tabViews)
        // 当删除标签的时候，需要判断删除的是否为报表，如果是报表需要删除所对应的cookie
      } else if (tabViews.length < this.copyTabViews.length) {
        this.deleteCookieWithTabViews(tabViews)
      }
      let cachedViews = []
      let oldDynamicCacheView = this.$_.cloneDeep(this.dynamicCacheView)
      tabViews.forEach((m, index) => {
        cachedViews.push(this.$_.pick(m, ['id', 'name', 'reportId']))
        //  标签页修改时。判断是否还有群组主页且没打开过的报表
        if (m.name === 'ReportRuntime' || m.name === 'FormRuntime' || m.name === 'PageRuntime') {
          let oldView = oldDynamicCacheView.find(n => n.id === m.id)
          if (oldView) {
            cachedViews[index].isFirst = oldView.isFirst
          }
        }
      })
      this.dynamicCacheView = cachedViews.filter(n => n.name === 'ReportRuntime' || n.name === 'FormRuntime' || n.name === 'PageRuntime')
      this.cachedViews = cachedViews.filter(n => !(n.name === 'ReportRuntime' || n.name === 'FormRuntime' || n.name === 'PageRuntime')).map(m => m.name)
    },
    firstEntry (tabViews) {
      let cachedViews = []
      tabViews.forEach((m, index) => {
        cachedViews.push(this.$_.pick(m, ['id', 'name', 'reportId']))
        if (index !== 0) {
          cachedViews[index].isFirst = true
        }
      })
      this.dynamicCacheView = cachedViews.filter(n => n.name === 'ReportRuntime' || n.name === 'FormRuntime' || n.name === 'PageRuntime')
      this.cachedViews = cachedViews.filter(n => !(n.name === 'ReportRuntime' || n.name === 'FormRuntime' || n.name === 'PageRuntime')).map(m => m.name)
    },
    getCurrentId (currentId) {
      if (currentId) {
        this.$nextTick(() => {
          this.dynamicCacheView.forEach((el, index) => {
            if (el.id === currentId) {
              this.dynamicCacheView[index].isFirst = false
            }
          })
        })
        this.defaultChoose = this.findDefaultChoose({children: this.headerMenu}, currentId).link
        this.currentMenuId = currentId
      }
    },
    pageTurn (e) {
      let myIdElement = document.getElementById('app')
      let evt = e || window.event
      if (evt.wheelDelta) { // 判断浏览器IE，谷歌滑轮事件
        if (Math.abs(evt.wheelDelta) > 0) {
          myIdElement.classList.add('has-background')
          this.num = 0
        }
      } else if (evt.detail) { // Firefox滑轮事件
        if (Math.abs(evt.detail) > 0) {
          myIdElement.classList.add('has-background')
          this.num = 0
        }
      }
    },
    // 排序
    sortBySort (a, b) {
      return a.sort - b.sort
    },
    toPoint (link, name) {
      if (link) {
        if (name === '技术支持') {
          this.functionalPoint.width = '40%'
          this.functionalPoint.support = true
        } else {
          this.functionalPoint.support = false
          this.functionalPoint.width = '80%'
          this.functionalPoint.functionId = link.split('/')[2]
        }
        this.functionalPoint.title = name
        this.functionalPoint.visible = true
      }
    },
    // 点击菜单
    clickMenu (index, menuId) {
      this.saveGuideChoose = this.guideChoose
      this.tabViewsLength = this.$refs.tagView.tabViews.length
      // 从developer调整过来的接口不需要进过安全校验
      let isTest = CookieOperation.get('isTest')
      !isTest && this.isSecurityById(menuId)
      if (index !== '') {
        this.index = index
        this.guideChoose = menuId
        this.homeMenu = this.headerMenu[index].children
        Vue.set(this.homeMenu)
      }
    },
    // 根据id判断是否为安全密码，及修改弹窗内容
    isSecurityById (menuId) {
      let _this = this
      this.$axios.get(`/auth-api/menus/${menuId}/isSecurityMenu`)
        .then((res) => {
          // 是安全报表
          if (res.data === true) {
            // 验证是否需要输入安全密码
            this.$axios.get('/auth-api/menus/needInputSecurityPassword')
              .then((res) => {
                // 需要输入安全密码（有8小时失效）
                if (res.data === true) {
                  _this.dialogTitle = '使用此功能需要输入安全密码'
                  // 是否设置安全密码
                  this.$axios.get('/auth-api/menus/haveSetSecurityPassword')
                    .then((res) => {
                      // 不需要设置安全密码
                      if (res.data.state === true) {
                        _this.hasSettingPwd = true
                        _this.dialogTitle = '使用此功能需要输入安全密码'
                        _this.cancelBtnText = '取消'
                        _this.confirmBtnText = '确定'
                        _this.centerDialogVisible = true
                        this.$nextTick(() => this.$refs.securityPassword && this.$refs.securityPassword.focus())
                      } else {
                        // 需要设置安全密码
                        _this.hasSettingPwd = false
                        _this.dialogTitle = '查看需要输入安全密码，由于您暂未设置安全密码，请前往设置'
                        _this.cancelBtnText = '暂不设置'
                        _this.confirmBtnText = '立即设置'
                        _this.centerDialogVisible = true

                        // 修改弹窗title，修改按钮状态，点击确认去设置安全密码，点击取消router.history
                      }
                    })
                }
              })
          }
        })
    },
    // 点击弹窗取消按钮
    dialogCancel () {
      this.centerDialogVisible = false
      this.errorMessage = ''
      this.guideChoose = this.saveGuideChoose
      this.lastRouter && this.$router.replace({name: 'index'})
      //  点击系统先看标签页的数据有没有添加不系统需要的标签页,
      if (this.$refs.tagView.tabViews.length !== this.tabViewsLength) {
        this.$refs.tagView.delLastTagView()
      }
      this.refresh()
    },
    // 点击弹窗确认按钮
    dialogConfirm () {
      let _this = this
      if (this.hasSettingPwd === false) {
        // 点击立即设置,删除刚刚出现的最后一个标签页
        this.currentMenuId = ''
        if (this.$refs.tagView.tabViews.length !== this.tabViewsLength) {
          this.$refs.tagView.delLastTagView()
        }
        this.$router.push({name: 'settingSecurityPassword'})
        _this.centerDialogVisible = false
      } else {
        // 校验密码
        if (!_this.securityPasswordForm.password) {
          _this.errorMessage = '安全密码不可为空'
          this.$refs.securityPassword && this.$refs.securityPassword.focus()
          return
        }
        let params = {
          'securityPw': _this.securityPasswordForm.password
        }
        this.$axios.get('/auth-api/menus/validateSecurityPassword', {
          params
        })
          .then((res) => {
            // 校验安全密码，密码正确关闭弹窗，密码错误提示错误，请重新输入
            if (res.data.state === true) {
              _this.centerDialogVisible = false
            } else {
              _this.errorMessage = res.data.message
              this.$refs.securityPassword && this.$refs.securityPassword.focus()
            }
          })
      }
    },
    // 二级or三级菜单点击
    toChildRouter (uuid, name, item) {
      // 给多标签有个名字
      for (let tag of this.dynamicCacheView) {
        if (tag.id === uuid && tag.isFirst) {
          tag.isFirst = false
          break
        }
      }
      if (name) {
        this.$route.meta.title = name
      }
      this.currentMenuId = uuid
      this.isSecurityById(uuid)
      this.$axios.post('/auth-api/menus/afterClickMenu', {menuId: item.id})
    },
    updateRecentlyUsed () {
      this.$axios.get('/auth-api/menus/recentlyUsed').then(res => {
        let recentlyUsed = res.data
        let historyList = []
        if (this.headerMenu.length) {
          recentlyUsed.forEach(m => {
            this.recursionMenus(this.headerMenu, item => {
              if (m.menuId === item.id) {
                item.menuId = item.id
                history && historyList.push(item)
              }
            })
          })
          this.historyList = historyList
        }
      })
    },
    upadteMostFrequentlyUsed () {
      this.$axios.get('/auth-api/menus/theMostFrequentlyUsed').then(res => {
        let theMostFrequentlyUsed = res.data
        let historyList2 = []
        if (this.headerMenu.length) {
          theMostFrequentlyUsed.forEach(m => {
            this.recursionMenus(this.headerMenu, item => {
              if (m.menuId === item.id) {
                item.menuId = item.id
                history && historyList2.push(item)
              }
            })
          })
          this.historyList2 = historyList2
        }
      })
    },
    // 导航刷新不变
    refresh () {
      let path = this.$router.history.current.fullPath
      if (this.headerMenu.length !== 0) {
        this.guideChoose = this.headerMenu[0].id
        this.defaultChoose = this.headerMenu[0].children[0].id
        this.homeMenu = this.headerMenu[0].children
        if (path !== '') {
          this.recursionMenus(this.headerMenu, (item, parent) => {
            if (item.link === path) {
              this.guideChoose = parent.id
              this.homeMenu = parent.children
              this.defaultChoose = item.link
              this.$router.push(item.link)
            }
          })
        }
      }
    },
    initDragable () {
      document.addEventListener('drop', (e) => {
        e.stopPropagation()
        e.preventDefault()
        e.dataTransfer.dropEffect = 'none'
        e.dataTransfer.effectAllowed = 'none'
      })
      document.addEventListener('dragover', (e) => {
        e.stopPropagation()
        e.preventDefault()
        e.dataTransfer.dropEffect = 'none'
        e.dataTransfer.effectAllowed = 'none'
      })
    },
    // 获取头部菜单背景色
    getElmenuBgColor (theme = '') {
      let themeColor = theme || (Vue.$theme && Vue.$theme.themeColor) || document.documentElement.getAttribute('theme')
      if (themeColor && themeColor !== 'defaultColor') {
        this.hasTheme = true
        this.menuColor.textColor = '#FFFFFF'
        this.menuColor.activeTextColor = '#FFFFFF'
        switch (themeColor) {
          case 'themeBlue':
            this.menuColor.mainColor = '#4592E4'
            break
          case 'themeGreen':
            this.menuColor.mainColor = '#2FA276'
            break
          case 'themeOrange':
            this.menuColor.mainColor = '#F67613'
            break
          case 'themeBrown':
            this.menuColor.mainColor = '#C59871'
            break
        }
      }
    },
    clearGlobalData () {
      Reflect.ownKeys(userInfo).forEach(key => {
        delete userInfo[key]
      })
    },
    // 登出
    logout () {
      document.cookie = 'securityPw=false'
      sessionStorage.removeItem('currentUserId')
      tokenStorage.removeToken()
      // 清理掉一些退出时要处理的全局数据，比如全局保存的用户信息
      this.clearGlobalData()
      this.$router.push({ name: 'login' })
    },
    // 切换标签页的时候,递归找到菜单选中的link
    findDefaultChoose  (current, id) {
      if (current.id === id) {
        return current
      }
      for (const item of current.children) {
        let restlt = this.findDefaultChoose(item, id)
        if (restlt) {
          return restlt
        }
      }
    },
    async getHistory () {
      if (this.keyword.trim() === '') {
        // 61th 新增最常使用功能,更新菜单最近使用逻辑,使用最新接口，故注释
        // await this.$axios.get('/auth-api/menuSearchRecord').then(res => {
        //   this.historyList = res.data || []
        // })
        // 最近使用
        this.updateRecentlyUsed()
        // 常用功能
        this.upadteMostFrequentlyUsed()
      } else {
        this.getMenuList(this.menuList, this.keyword.trim())
      }
      this.showList = true
    },
    clearList () {
      setTimeout(() => {
        this.showList = false
        this.searchMenuList = []
        this.keyword = ''
      }, 200)
    },
    itemClick (item) {
      this.currentMenuId = item.menuId
      this.$router.push({path: `/main${item.link}`})
      this.isSecurityById(item.menuId)
      // 61th 新增最常使用功能,更新菜单最近使用逻辑,使用最新接口，故注释
      // let params = {...item}
      // this.$axios.post('/auth-api/menuSearchRecord', params)
      this.$axios.post('/auth-api/menus/afterClickMenu', {menuId: item.id || item.menuId})
      this.keyword = ''
    },
    findDoingTask  (current, name) {
      if (current.name === name) {
        return current
      }
      for (const item of current.children) {
        let restlt = this.findDoingTask(item, name)
        if (restlt) {
          return restlt
        }
      }
    },
    menuHide () {
      this.isCollapse = !this.isCollapse
      this._provided.leftMenu.width = this.isCollapse ? 0 : 200
    },
    getMenuList (arr, str) {
      str = str.toLowerCase()
      arr && arr.length && arr.forEach(c => {
        // 父级菜单应该是不需要搜索出来的
        if (c.link && (!c.children || c.children.length === 0)) {
          if (c.name.includes(str) || (c.pinyinFirstChar && c.pinyinFirstChar.includes(str)) || (c.pinyinName && c.pinyinName.includes(str))) {
            this.searchMenuList.length < 10 && this.searchMenuList.push({menuName: c.name, link: c.link, menuId: c.id})
          }
        }
      })
    },
    // 自定义事件,可以处理标签页等
    customEvent (customObj = {}) {
      if (customObj.type === 'customClass') {
        let currentReportTag = this.$refs.tagView.tabViews.find(e => e.id === customObj.id)
        currentReportTag && this.$set(currentReportTag, 'customClass', customObj.customClass)
      }
    },
    // 自定义 - 路由跳转(标签跳转事件)
    activeTagEvent (reportId) {
      if (this.$refs.report) {
        let currentReport = this.$refs.report.find(e => e.id === reportId)
        currentReport && currentReport.eventBus.$emit('tags-view-active', reportId)
      }
    },
    setCookieWithReport (key, value) {
      let reports = localStorage.getItem('reportScrollTop')
      reports = reports ? JSON.parse(reports) : {}
      reports[key] = value
      localStorage.setItem('reportScrollTop', JSON.stringify(reports))
    },
    deleteCookieWithTabViews (tabViews) {
      let reports = localStorage.getItem('reportScrollTop')
      reports = reports ? JSON.parse(reports) : {}
      let keys = Object.keys(reports)
      // 需要删除已经关闭的报表标签数据
      if (keys && keys.length && tabViews) {
        for (let i = 0; i < keys.length; i++) {
          if (!tabViews.find(t => t.fullPath.includes(keys[i]))) {
            delete reports[keys[i]]
          }
        }
      }
      localStorage.setItem('reportScrollTop', JSON.stringify(reports))
    },
    /*
    * 处理菜单数据
    * @param {Array} menus [{pc菜单}, {功能点}]
    * @return 获取处理过后的menus
    * */
    getDisposeMenus (menus) {
      // 如果是admin账号，则在系统菜单下追加admin默认菜单 adminDefaultMenu
      if (this.isAddMenu === true) {
        let systemMenu = menus.find(m => m.name === '系统' && parseInt(m.isBuiltIn) === 1)
        systemMenu && systemMenu.children && systemMenu.children.push(this.adminDefaultMenu)
      }
      let menuIds = []
      // 所有menu整合到一个数组中
      let menusList = []
      this.recursionMenus(menus, item => {
        item.show = true
        menuIds.push(item.id)
        menusList.push(item)
      })
      return {menus, menuIds, menusList}
    },
    // 递归菜单
    recursionMenus (menus, callback = () => {}) {
      for (let i = 0; i < menus.length; i++) {
        callback(menus[i], menus)
        menus[i].children && menus[i].children.length && this.recursionMenus(menus[i].children, callback)
      }
    }
  },
  watch: {
    keyword (val) {
      this.searchMenuList = []
      if (val && val.trim() !== '') {
        this.$nextTick(() => this.getMenuList(this.menuList, val))
      }
    },
    centerDialogVisible (val) {
      val && this.$nextTick(() => this.$refs.securityPassword && this.$refs.securityPassword.focus())
    },
    currentMenu: {
      handler (val) {
        if (val) {
          let item = this.findDefaultChoose({children: this.headerMenu}, val.id)
          if (item) {
            this.currentMenuId = item.id
            this.$router.push({path: `/main${item.link}`})
            this.isSecurityById(item.id)
          } else {
            // 如果通过id在菜单列表中没有找到该菜单
            this.$message.error('菜单不存在或没有权限')
          }
        }
      },
      deep: true
    },
    $route (newValue, oldValue) {
      // 离开页面的时候，存一分报表滚动条高度位置
      if (oldValue && oldValue.name.includes('ReportRuntime')) {
        if (oldValue.path && this.$refs && this.$refs.report) {
          let id = oldValue.path.split('/').slice(-1)[0]
          let report = this.$refs.report.find(f => f.id === id)
          report && this.setCookieWithReport(id, report.$refs.report.$refs.tablePaganition.$refs.table.bodyWrapper.scrollTop)
        }
      }
    }
  }
}
// const defaultLogo = require('./assets/redcat.png')
</script>

<style lang="scss">
  .index-container {
    height: 100%;
    width: 100%;
    position: relative;
    .app-index {

      &,
      >.el-container,
      >.el-container>main,
      >.el-container>main>.content-container {
        height: 100%;
      }

      .security-dialog .el-dialog__header {
        padding: 0;
        height: 34px;
        line-height: 34px;
      }
      .security-dialog .el-dialog__body {
        text-align: center;
        padding: 24px 0 0 0;

        .hasSettingPwd {
          padding: 0 24px;
        }

        .el-form {
          margin-top: 25px;
          .el-input__inner {
            width: 190px;
            height: 28px;
            border: 1px solid #C2C3C4;
            border-radius: 4px;
          }
        }
      }
      .security-dialog .el-dialog__footer {
        padding: 19px 0 23px 0;
        .el-button {
          width:82px;
          height:26px;
          padding: 0;
          border: 1px solid var(--primary, #54ABF1);
          border-radius: 4px;
          color: var(--primary, #54ABF1);
          &:hover, &:active, &:focus {
            background-color: #fff;
            color: var(--primary, #54ABF1);
          }
        }
        .el-button--primary {
          margin-right: 50px;
          color: #fff;
          background-color: var(--primary, #54ABF1);
          &:hover, &:active, &:focus {
            background-color: var(--primary, #54ABF1);
            color: #fff;
          }
        }
      }
      .header-functional-point .el-dialog{
        .el-dialog__body{
          height: 580px;
          padding-top: 0;
        }
      }
      .header-functional-point.functional-point-help-height .el-dialog{
        .el-dialog__body{
          height: unset;
          padding-top: 30px;
        }
      }

      >.el-header {
        border-bottom: solid 1px var(--primary, #e6e6e6);
        background: var(--primary, #fff);

        .logo,
        .homePageMenu {
          float: left;
          li,.el-menu-item{
            height: 43px;
            line-height: 43px;
          }
          &.homePageMenu-theme{
            li,.el-menu-item{
              color: #FFFFFF;
            }
          }
        }

        .logo {
          display: flex;
          align-items: center;
          width: 190px;
          padding: 5px;
          height: 100%;
          .logo-img {
            width: 128px;
            img {
              width: 100%;
            }
          }
          .log-app-name{
            width: 100%;
            p{
              font-family: Yuanti SC;
              font-weight: bold;
              font-size: 16px;
              color: #909399;
              letter-spacing: 3px;
            }
            &.log-app-name-theme-color{
              p{
                color: #FFFFFF;
              }
            }
          }
        }

        .user {
          float: right;
          line-height: 43px;

          .username {
            color: #4d95d4;
            cursor: pointer;
            .username-padding{
              padding: 2px 14px 2px 12px;
            }
            .username-border-right {
              border-right: 1px solid #D2E0F4;
            }
            &.username-theme{
              color: #FFFFFF;
            }
          }

          .point {
            display: inline;
            margin-right: 10px;

            .icon-button {
              border: none;
              &:active,
              &:hover {
                background-color: #fff;
              }
            }
            &.point-theme{
              .icon-button {
                background-color: var(--primary, #FFFFFF);
                i{
                  color: #FFFFFF;
                  &:hover{
                    color: #e2e2e2;
                  }
                }
              }
            }
          }

          .fa {
            font-size: 20px;
            cursor: pointer;
          }
          &.user-theme{
            .fa{
              color: #FFFFFF;
            }
          }
        }
      }

      >.el-container {
        height: calc(100% - 61px);

        .menuHide {
          display: inline-block;
          width: 5px;
          height: 24px;
          background: url(./assets/常态1.png) no-repeat center center;
          position: fixed;
          top: 45px;
          left: 200px;
          z-index: 1;
          cursor: pointer;
          filter: drop-shadow(2px 1px 1px #EFEFEF);
          &:hover{
            background-image: url(./assets/掠过点击1.png);
          }
          &.menuShow{
            background-image: url(./assets/常态2.png);
            &:hover{
              background-image: url(./assets/掠过点击2.png);
            }
          }
        }

        >.app-index-aside {
          background: #29282e;
          height: 100%;
          width: 200px;
          float: left;
          overflow: auto;
          position: relative;

          &.app-index-aside-theme{
            background: #F5F5F5;
            box-shadow: 0px 3px 8px 0px rgba(132, 150, 168, 0.21);
            .search-list{
              background-color: #F5F5F5;
              .list-container{
                background-color: #F5F5F5;
              }
            }
            .search{
              .el-input__inner{
                background-color: #F5F5F5;
                color: #606266;
              }
            }
          }

          .search-list {
            position: absolute;
            top: 36px;
            left: 0;
            width: 100%;
            height: calc(100% - 55px);
            background-color: #29282e;
            z-index: 9999;

            .list-container {
              width: 172px;
              margin: 0 auto;
              background-color: #000;
              box-shadow:0 3px 8px 0 rgba(184,222,253,0.2);
              max-height: 390px;
              color: #fff;
              font-size:12px;
              &.list-container-color{
                color: #232323;
              }

              .list {
                max-height: 180px;
                overflow: hidden;
                .item {
                  padding: 14px 0 0 9px;
                  box-sizing: border-box;
                  width: 172px;
                  overflow:hidden;
                  text-overflow:ellipsis;
                  white-space:nowrap;
                  cursor: pointer;
                  -webkit-user-select: none;
                  -moz-user-select: none;
                  -ms-user-select: none;
                  user-select: none;
                  text-align: left;
                  &:hover {
                    color: var(--primary, #54ABF1);
                  }
                }
                .no-history, .no-search {
                  text-align: center;
                  padding-top: 20px;
                }
              }

              .list:nth-child(4) {
                padding-bottom: 14px;
              }

              & > .title {
                color: #859AAB;
                font-size:12px;
                padding: 14px 0 0 10px;
              }
            }

            .history-result {
              max-height: 400px;
              color: #C3CCDC;
              .list {
                .item {
                  padding: 13px 0 0 9px;
                  width: 130px;
                }
                .no-search {
                  padding-top: 110px;
                }
              }
            }

            .search-result-list {
              .list {
                min-height: 360px;
              }
            }
          }

          .search {
            text-align: center;
            margin: 8px 0 0 14px;
            width: 172px;
            box-sizing: border-box;
            .el-input__inner {
              background: #29282e;
              color: #fff;
              width: 172px;
              padding: 0 0 0 8px;
            }
          }

          .el-menu-vertical {
            height: calc(100% - 37px);
            overflow: auto;
            color: #fff;
            &.el-menu-vertical-theme{
              // 框架会动态设置他的触摸样式，这里必须要加 important 才能生效，所以要注意使用BEM规范进行约束
              .index-menu-list-container{
                .el-menu-item{
                  &:hover{
                    background-color: #ECECEC !important;
                  }
                  &.active-menu{
                    background-color: #E6E6E6 !important;
                  }
                }
              }
              .el-submenu{
                .el-menu-item:hover,.el-submenu__title:hover{
                  background-color: #ECECEC !important;
                }
                .active-menu{
                  background-color: #E6E6E6 !important;
                }
              }
            }
          }
          .el-menu {
            border-right: none;
            .el-submenu {
              .el-menu-item{
                height: 32px;
                line-height: 32px;
                padding-right: 0;
              }
              .active-menu {
                // 因为路由中加了 main 导致内置的 active-text-color 失效了，而且 text-color是通过style加进去的属性
                color: var(--primary, #4d95d4) !important;
                border-right:2px solid var(--primary, #29282e) !important;
              }
            }
          }
          .el-menu-item,.el-submenu__title{
            height: 38px;
            line-height: 38px;
          }
          .el-menu-item.is-disabled {
            opacity: 1;
            cursor: pointer;
          }
          .el-menu {
            width: auto;
            height: 100%;
            div, li, ul {
              width: auto;
            }
          }
          .menu-container {
            width: 100%;
            overflow: auto;
            height: calc(100% - 37px);
            & > .el-menu {
              height: 100%;
            }
            &.menu-container-theme > .el-menu{
              background: url("./assets/menu-container-bg.png") no-repeat 0% 100%;
            }
          }
          .el-menu {
            .el-submenu__title {
              box-sizing: content-box;
              min-width: 120px;
              .el-submenu__icon-arrow {
                right: 10px;
              }
            }
          }
        }

        >main {
          padding: 8px;
          background: #f8fbfe;
          float: right;
          width: calc(100% - 220px);
          height: 100%;
          >.content-container {
            min-height: 520px;
            height: calc(100% - 30px);
            border: 1px solid #e6e6e6;
            border-top: none;
          }
        }
      }
    }
    .index-model {
      text-align: center;
      position: absolute;
      padding-top: calc(25% - 180px);
      width: 100%;
      height: 100%;
      background-color: #fff;
      div {
        text-align: center;
      }
      .model-title {
        .tenant-name {
          font-weight: 800;
          font-size: 20px;
          margin: 5px 0 30px 0;
        }
      }
      .model-body {
        color: #999;
        font-size: 16px;
        a{
          font-size: 16px;
        }
      }
    }
  }
  .el-table {
    th {
      >.cell {
        color: #181818;
        font-weight: 400;
      }
    }
    td {
      color: #000;
    }
  }
  .el-textarea__inner {
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/system/index.vue